import { render, staticRenderFns } from "./quiz-landing.html?vue&type=template&id=1dd2e1e5&scoped=true&external"
import script from "./quiz-landing.vue?vue&type=script&lang=js"
export * from "./quiz-landing.vue?vue&type=script&lang=js"
import style0 from "./quiz-landing.css?vue&type=style&index=0&id=1dd2e1e5&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd2e1e5",
  null
  
)

export default component.exports